const IMAGE_CACHE_DIR_NAME = 'op_message_image_cache';

let _messageImageCacheDir = null;

function IMAGE_CACHE_DIR_PATH() {
  console.warn('not available on web');
}

// export function messageImageCacheDir() {
//   let cacheDirPath = IMAGE_CACHE_DIR_PATH();
//   if (_messageImageCacheDir == cacheDirPath) {
//     return Promise.resolve(_messageImageCacheDir);
//   }
//
//   let mkdirOptions = {
//     NSURLIsExcludedFromBackupKey: false,
//   };
//   return RNFS.mkdir(cacheDirPath, mkdirOptions).then(() => {
//     _messageImageCacheDir = cacheDirPath;
//     console.log('Image Cache created cache dir at', _messageImageCacheDir);
//     return _messageImageCacheDir;
//   });
// }

export function clearMessageImageCache() {
  console.warn('not available on web');
  return Promise.resolve('not available on web');
}
